<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex lg12 md12 xl12 xs12>
          <v-card>
            <v-card-title primary-title>
              <h2 class="display-1 mb-0">Versorgungspunkt {{ checkpoint.title }}</h2>
            </v-card-title>
            <v-card-text>
              <p>
                Es sind noch {{ participantsRunning }} Personen auf der Strecke<br>
                Passwort: {{ checkpoint.token }}<br>
              </p>
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex xs12 mg6 lg4 xl3 v-for="participant in getParticipants()" :key="participant.id">
                    <v-card :class="{'canceled': hasParticipantCanceled(participant), 'finished': hasParticipantFinishedThisCheckpoint(participant)}">
                      <v-card-title>
                        <h2 class="display-4">{{ participant.startNumber }}</h2>
                      </v-card-title>
                      <v-card-text>
                        <h3 class="display-1">{{ participant.firstname }} {{ participant.lastname }}</h3>
                        <p>{{ getCategoryById(participant.category).title }}<br>
                          <a :href="'tel:'+participant.phone">{{participant.phone}}</a></p>
                        <p>Letzter VP: {{ participant.lastCheckpointTime }}</p>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="success" @click="setTime(participant)" v-if="!hasParticipantFinishedThisCheckpoint(participant) || hasParticipantCanceled(participant)">Zeit nehmen</v-btn>
                        <v-btn color="success" @click="setTime(participant)" v-else>{{ getCheckpointTimeOfParticipant(participant) }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="setCancel(participant)" v-if="!hasParticipantCanceled(participant)">Abbrechen</v-btn>
                        <v-btn color="error" @click="setCancel(participant)" v-else>{{ getCheckpointTimeOfParticipant(participant) }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>
            <v-card-actions>

            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

  import TimeService from "../services/TimeService";

  export default {
    components: {},
    props: ['token'],
    computed: {
      event() {
        return this.$store.state.event
      },
      categories() {
        return this.$store.state.categories
      },
      participants() {
        return this.$store.state.participants
      },
      checkpoint() {
        let checkpoint = this.$store.state.checkpoints.find(checkpoint => checkpoint.token === this.token)
        if (checkpoint === undefined) {
          return {
            title: '',
            categories: []
          }
        }
        return checkpoint
      }
    },
    data: function () {
      return {
        participantsRunning: 0
      }
    },
    methods: {
      getCategories (checkpoint) {
        let categories = []
        if (checkpoint.categories.length > 0) {
          checkpoint.categories.forEach(id => {
            categories.push(this.categories.find(category => id === category.id))
          })

        }
        return categories
      },
      getCategoryById (categoryId) {
        return this.categories.find(category => category.id === categoryId)
      },
      getParticipants () {
        let categories = [];
        this.getCategories(this.checkpoint).forEach(category => {
          categories.push(category.id)
        })
        let participantsRunning = [];
        let participantsFinished = [];
        let participantsCanceled = [];
        let participantsOpened = [];

        this.participants.forEach(participant => {
          if (categories.includes(participant.category)) {
            if (this.hasParticipantCanceled(participant) === true) {
              participantsCanceled.push(participant)
            } else if (this.hasParticipantFinishedThisCheckpoint(participant)) {
              participantsFinished.push(participant)
            } else if (participant.startNumber !== null) {
              participantsRunning.push(participant)
            } else {
              participantsOpened.push(participant)
            }
          }
        })
        this.participantsRunning = participantsRunning.length
        participantsRunning.sort((a, b) => {
          if (a.lastCheckpointTimestamp != null && b.lastCheckpointTimestamp != null) {
            return a.lastCheckpointTimestamp - b.lastCheckpointTimestamp
          } else if (a.lastCheckpointTimestamp != null) {
            return -1
          } else if (b.lastCheckpointTimestamp != null) {
            return 1
          }
          return a.startNumber - b.startNumber
        })
        participantsFinished.sort((a, b) => {
          return a.startNumber - b.startNumber
        })
        participantsCanceled.sort((a, b) => {
          if (a.startNumber === null) {
            return 1
          } else if (b.startNumber === null) {
            return -1
          }
          return a.startNumber - b.startNumber
        })
        return participantsRunning.concat(participantsFinished, participantsCanceled, participantsOpened)
      },
      setTime (participant) {
        TimeService.update(this.token, {
          participantId: participant.id,
          checkpointId: this.checkpoint.id,
          cancel: false
        }).then(() => {
          this.$store.dispatch('loadEvent', this.event.token)
        })
      },
      setCancel (participant) {
        TimeService.update(this.token, {
          participantId: participant.id,
          checkpointId: this.checkpoint.id,
          cancel: true
        }).then(() => {
          this.$store.dispatch('loadEvent', this.event.token)
        })
      },
      hasParticipantCanceled(participant) {
        if (participant.canceled === true) {
          return true
        }
        if (participant.timeEntries.length > 0) {
          return participant.timeEntries.find(time => time.checkpoint === this.checkpoint.id && time.canceled === true) !== undefined
        }
        return false
      },
      hasParticipantFinishedThisCheckpoint(participant) {
        if (participant.timeEntries.length > 0) {
          return participant.timeEntries.find(time => time.checkpoint === this.checkpoint.id && time.datetime !== null && time.canceled !== true) !== undefined
        }
        return false
      },
      getCheckpointTimeOfParticipant(participant) {
        if (participant.timeEntries.length > 0) {
          const time =  participant.timeEntries.find(time => time.checkpoint === this.checkpoint.id)
          if (time !== undefined && time.datetime !== null) {
            return time.datetime.substr(0, time.datetime.length - 3)
          }
        return 'Abgebrochen'
        }

        return 'Abgebrochen'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .canceled {
    background-color: #ffe9e5;
  }
  .finished {
    background-color: #c8e6c9;
  }
</style>
